/* eslint-disable max-len */
import { CommonModule } from '@angular/common';
import {
  Component, EventEmitter, OnDestroy, OnInit
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { IState, StatesServedStore } from '@sondermind/data-access/public-facing/states-served';

import { PublicFooterModule } from '@sondermind/features/app-footer';
import { PublicHeaderModule } from '@sondermind/features/app-header';
import { EmptyURIValue, URIPrefix } from '@sondermind/features/filter-form';
import { USStateOptions } from '@sondermind/constants';
import { takeUntil } from 'rxjs';

@Component({
  standalone: true,
  selector: 'browse-page',
  templateUrl: './browse-page.component.html',
  styleUrls: ['./browse-page.component.scss'],
  imports: [
    CommonModule,
    PublicFooterModule,
    PublicHeaderModule,
    RouterModule
  ]
})

export class BrowsePage implements OnInit, OnDestroy {
  statesList: IState[];
  uriPrefix = URIPrefix;
  emptyURIValue = EmptyURIValue;
  destroyed$ = new EventEmitter<void>();

  constructor(private statesServedStore: StatesServedStore) {}

  ngOnInit(): void {
    this.getStatesList();
  }

  getStatesList(): void {
    this.statesServedStore.stateList$()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((response: IState[]) => {
        this.statesList = response;
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
  }
}
